import { render } from "./Admin2FAModal.vue?vue&type=template&id=b9286040&scoped=true&ts=true"
import script from "./Admin2FAModal.vue?vue&type=script&lang=ts"
export * from "./Admin2FAModal.vue?vue&type=script&lang=ts"

import "./Admin2FAModal.vue?vue&type=style&index=0&id=b9286040&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9286040"]])

export default __exports__